import React, { Component } from 'react';
import Social from '../components/Social'
import { Fade } from "react-awesome-reveal";
import ButtonMailto from '../components/MailButton.js'

/*
<div className="consec" style={{"border-top":"none", "border-bottom":"none"}} id="research_projects">
  <div className="section-title">Research Projects</div>
  <div className='consec' style={{"padding-top":"1rem", "padding-bottom":"1rem"}}>
    <div className="card_container">
      <Card
        title={"TupperwareEarth"}
        subtitle={"Kitchen IoT to Advance Cooking Convenience"}
        description={"TupperwareEarth is an intelligent network of smart devices with the capability of \"understanding\" the user and the relevant parts of the environment that impact kitchen activities. We leverage ontology-based semantic knowledge to help reduce the cognitive loads of the user."}
        img={"/ble.png"}
        topaper={"https://ieeexplore.ieee.org/stamp/stamp.jsp?arnumber=9674047&casa_token=eN4UHl5hXO4AAAAA:E8ISKjZSk4VQrj81AdxNEpXP8oC83smQ-IouuwyV7L429DKtCUpTCa9rNoYcSZ5x_5LngR70&tag=1"}
        tolink={"https://web.ics.purdue.edu/~rvoyles/research.tupperware.html"}
      />
      <Card
        title={"RoboMal"}
        subtitle={"Malware Detection on Robotic Systems"}
        description={"We address the need for malware detection in robotic  systems  by  presenting  a  learning-enabled  framework and a dataset of 450 control programs for an autonomous car robot. The  aim  of  this  work  is  to  detect  malware  before the attacker even has a chance to install or execute, thereby greatly limiting the impact that malware can have."}
        img={"/robomal.png"}
        todataset={"https://purr.purdue.edu/publications/3860"}
      />
      <Card
        title={"Precision Animal Agriculture"}
        subtitle={"IoT for Cow Agriculture"}
        description={"In this project, our CPS reference architecture is utilized to achieve individualized care of animals to enhance farm productivity, animal health and safety, as well as animal welfare and anxiety."}
        img={"/paag.png"}
        tolink={"https://web.ics.purdue.edu/~rvoyles/research.animalAg.html"}
      />
      <Card
        title={"Parsing Network Documentations"}
        subtitle={"Sequence Tagging in Network Protocol Documents"}
        description={"In this project, we developed deep learning models to process network protocol documentations written in English. We used a Char-LSTM-CRF architecture and used begining-inside-outside tags to parse control logic described in the documentations."}
        img={"http://colah.github.io/images/post-covers/lstm.png"}
      />
      <Card
        title={"SoK: Mobile Sensor Side-Channels"}
        subtitle={"Systematic Categorization and User Study"}
        description={"Mobile devices, such as smartphones and smart wearables, have been integrated with various sensing and actuating modules, such as motion sensors, cameras, GPS, speakers, which enabled rich functionalities in powerful mobile applications. Yet, vast literature recently demonstrated that these modules can be used maliciously for side-channel attacks, which impose serious risks to privacy."}
        img={"http://trueviewvisuals.com/wp-content/uploads/2015/02/RZcrG.jpg"}
      />
      <Card
        title={"Intermittent Device Attack"}
        subtitle={"Recovering Private Information through Physical Side Channels"}
        description={"Intermittent computing enables batteryless devices to operate using the harvested environmental energy, such as radio waves, weak solar energy, and vibration. Yet, the privacy implications of intermittent devices are largely unexplored. In this project, we conduct a side-channel attack on batteryless devices to extract sensitive information about users’ activities."}
        img={"https://uploads-ssl.webflow.com/58de5a002efbcf655ab4677e/5c7d70c37c9ef40e8ec2c2ec_il2HZ4DnEuczmlYTSwN0FywMvHFqz0kM5prBcRIANHfqivmh1kEPRVQF5yxxuymh-hMOFLbS87eAWjbVWkQNhkM0icq7K-pO1Pnh4ua7y1joaINQ5Lh44QFYHOKGBUvv8sNJPzS9.png"}
      />
      <Card
        title={"Testing Deep Learning Library"}
        subtitle={"Create Equivalence Graph in PyTorch and Tensorflow"}
        description={"In this project, we proposed a new approach to test deep learning libraries, which is to generate equivalent graphs of computation. Equivalent graphs during execution are expected to produce outputs within an error bound."}
        img={"https://miro.medium.com/max/481/0*ohO11wTD8DCUMVR8"}
      />
    </div>
  </div>
</div>
</Fade>
<Fade>
<div className="consec" style={{"border-top":"none", "border-bottom":"none"}} id="awards">
  <div className="section-title">Honors & Awards</div>
  <div className='consec' style={{"border-bottom":"none"}}>
    <br/>
    <div style={{"display":"block"}}>
      <ul style={{"padding-left":"1rem", "padding-right":"1rem"}}>
        <li> Graduation with Highest Distinction, Purdue University  <p style={{"float":"right"}}> December 2021 </p> </li>
        <li>World-Wide: 3rd Place at SAE MobilityForward Challenge - AI Mini Challenge  <a className="papera" href="https://saemobilityforwardchallenge.com/">[Challenge]</a> <p style={{"float":"right"}}> November 2021 </p> </li>
        <li>College of Science Alumni Summer Research Fellowship, Purdue University <p style={{"float":"right"}}> April 2021 </p> </li>
        <li>Most Marketable Project Award, Smart Software Hackathon, Purdue University &nbsp;
        <a className="papera" href="https://docs.google.com/presentation/d/e/2PACX-1vRpz56QrLauhpU_tZd4XgXtaaWO9NWEfCVAzCzeZAfr6onzXQqv36qX5bDkwKFXEpvtjiWI2NSLl2oc/pub?start=true&loop=true&delayms=3000">[Slides]</a> &nbsp;
        <a className="papera" href="https://github.com/haozheee/EmoSwiper">[GitHub]</a>
        <p style={{"float":"right"}}>April 2021</p> </li>
        <li>Summer Stay Scholars Scholarship, Purdue University<p style={{"float":"right"}}>May 2020</p></li>
        <li>Best-Over-All Award, Hello World Hackathon, Purdue University &nbsp;
        <a className="papera" href="https://devpost.com/software/hellotab-aump64">[Devpost]</a> &nbsp;
        <a className="papera" href="https://github.com/TigerHix/HelloTab">[GitHub]</a> <p style={{"float":"right"}}>October 2018</p></li>
        <li>Computer Science Honors Program, Purdue University  <p style={{"float":"right"}}>2019 - 2021</p></li>
        <li>Dean’s List and Semester Honors, Purdue University <p style={{"float":"right"}}>2019 - 2021</p></li>
      </ul>
      </div>
    <br/>
  </div>
</div>
</Fade>
*/

class Home extends Component {
  constructor(props) {
      super(props);
    this.state = {
          'isTablet': false,
      'isPhone': false
      }
    this.updateDimensions = this.updateDimensions.bind(this);
  }

  componentDidMount() {
    window.history.pushState(null, document.title, window.location.href);
    window.addEventListener('popstate', function (event) {
      window.history.pushState(null, document.title, window.location.href);
    });
    window.addEventListener('resize', this.updateDimensions);
  }

  updateDimensions() {
    var w = window,
       d = document,
       documentElement = d.documentElement,
       body = d.getElementsByTagName('body')[0],
       width = w.innerWidth || documentElement.clientWidth || body.clientWidth,
      height = w.innerHeight || documentElement.clientHeight || body.clientHeight;
    this.setState({ 'isTablet': width < 1380 })
    this.setState({ 'isPhone': width < 1023 })
  }

   componentWillMount() {
        this.updateDimensions();
  }

   componentWillUnmount() {
     window.removeEventListener('resize', this.updateDimensions);
   }

    render() {
        return (
            <div className="conparent" style={{"border-top": "none"}}>
                <Fade cascade>
                <div className="consec" style={{"border-top": "none", "border-bottom": "none"}}>
                    <div className="consec" style={{"border-top": "none"}}>
                    {!this.state.isPhone &&
                      <div style={{"display":"block"}}>
                      <img src={"./photo.jpg"} className="conimg-s" alt="Haozhe Zhou"/>
                      <div className="profile-content">
                        <h3 className="profile-name">Haozhe Zhou 周浩哲</h3>
                        
                        <div className="introduction-section">
                          <p>
                            Hi, I'm Haozhe. I am a PhD student in <a href="https://sc.cs.cmu.edu/" target="_blank" rel="noopener noreferrer" className="cmu-link">Societal Computing</a> in the <a href="https://www.cs.cmu.edu/" target="_blank" rel="noopener noreferrer" className="cmu-link">School of Computer Science</a> at Carnegie Mellon University. 
                            I'm advised by <strong><a href="https://www.synergylabs.org/yuvraj/index.html" target="_blank" rel="noopener noreferrer" className="cmu-link">Yuvraj Agarwal</a></strong> and <strong><a href="http://www.mayankgoel.com/" target="_blank" rel="noopener noreferrer" className="cmu-link">Mayank Goel</a></strong>, under the <a href="https://www.synergylabs.org/" target="_blank" rel="noopener noreferrer" className="cmu-link">Synergy Labs</a> and <a href="https://smashlab.io/" target="_blank" rel="noopener noreferrer" className="cmu-link">SmaSH Lab</a>. 
                            My research focuses on enabling scalable and generalizable human sensing systems that operate reliably in heterogeneous real-world environments. I am particularly interested in the machine learning and system foundations that enable sensing and perception to adapt across diverse sensors, placements, and contexts, while also balancing privacy considerations and user needs.
                          </p>
                          <p>
                            My current work focuses on building systems that enable flexible and privacy-preserving human sensing across diverse real-world contexts. Through projects like <a href="#publications" className="cmu-link">IMUCoCo</a> for adaptable IMU placement, <a href="#publications" className="cmu-link">ThingPoll</a> for privacy negotiation in shared spaces, and <a href="#publications" className="cmu-link">Kirigami</a> for speech-filtered audio sensing, I explore how sensing systems can adapt to different devices, placements, and user requirements while maintaining accuracy and respecting privacy. 
                         </p>
                        </div>

                        <div className="profile-details">
                            <div className="education-section">
                             <h5>Education</h5>
                              <div className="education-entries">
                                <div className="education-entry">
                                  <p><strong>Ph.D.</strong> Carnegie Mellon University<br/>
                                  School of Computer Science, Societal Computing<br/>
                                  2022/08 - Present</p>
                                </div>
                                <div className="education-entry">
                                  <p><strong>B.S.</strong> Purdue University<br/>
                                  Department of Computer Science, Computer Science Honors<br/>
                                  2018/08 - 2021/12</p>
                                </div>
                              </div>
                            </div>

                          <div className="research-interests">
                            <h5>Research Interests</h5>
                            <p>Ubiquitous Computing · Machine Learning for Sensing · Human Pose Estimation · Human Activity Recognition · Privacy</p>
                          </div>
                        </div>
                      </div>
                      </div>
                    }
                    {this.state.isPhone &&
                      <div style={{"border-top": "none"}}>
                      <img src={"./photo.jpg"} className="conimg-s" alt="Haozhe Zhou"/>
                      <div className="profile-content-mobile">
                        <h3 className="profile-name">Haozhe Zhou 周浩哲</h3>
                        
                        <div className="introduction-section">
                          <p>
                            Hi, I'm Haozhe. I am a PhD student in <a href="https://sc.cs.cmu.edu/" target="_blank" rel="noopener noreferrer" className="cmu-link">Societal Computing</a> in the <a href="https://www.cs.cmu.edu/" target="_blank" rel="noopener noreferrer" className="cmu-link">School of Computer Science</a> at Carnegie Mellon University. 
                            I'm advised by <strong><a href="https://www.synergylabs.org/yuvraj/index.html" target="_blank" rel="noopener noreferrer" className="cmu-link">Yuvraj Agarwal</a></strong> and <strong><a href="http://www.mayankgoel.com/" target="_blank" rel="noopener noreferrer" className="cmu-link">Mayank Goel</a></strong>, under the <a href="https://www.synergylabs.org/" target="_blank" rel="noopener noreferrer" className="cmu-link">Synergy Labs</a> and <a href="https://smashlab.io/" target="_blank" rel="noopener noreferrer" className="cmu-link">SmaSH Lab</a>. 
                            My research explores how to build scalable and generalizable human sensing systems that operate reliably in heterogeneous real-world environments. I am particularly interested in the machine learning and system foundations that enable sensing and perception to adapt across diverse sensors, placements, and contexts, while also balancing privacy considerations and user needs.
                          </p>
                          <p>
                            My current work focuses on building systems that enable flexible and privacy-preserving human sensing across diverse real-world contexts. Through projects like <a href="#publications" className="cmu-link">IMUCoCo</a> for adaptable IMU placement, <a href="#publications" className="cmu-link">ThingPoll</a> for privacy negotiation in shared spaces, and <a href="#publications" className="cmu-link">Kirigami</a> for speech-filtered audio sensing, I explore how sensing systems can adapt to different devices, placements, and user requirements while maintaining accuracy and respecting privacy. 
                         </p>
                     </div>

                        <div className="profile-details">
                          <div className="education-section">
                            <h5>Education</h5>
                            <div className="education-entries">
                              <div className="education-entry">
                                <p><strong>Ph.D.</strong> Carnegie Mellon University<br/>
                                School of Computer Science, Societal Computing<br/>
                                2022/08 - Present</p>
                              </div>
                              <div className="education-entry">
                                <p><strong>B.S.</strong> Purdue University<br/>
                                Department of Computer Science, Computer Science Honors<br/>
                                2018/08 - 2021/12</p>
                              </div>
                            </div>
                          </div>

                          <div className="research-interests">
                            <h5>Research Interests</h5>
                            <p>Ubiquitous Computing · Machine Learning for Sensing · Human Pose Estimation · Human Activity Recognition · Privacy</p>
                          </div>
                        </div>
                      </div>
                     </div>
                    }
                  </div>
                </div>
                </Fade>

                <Fade>
                <div className="consec" style={{"border-top":"none", "border-bottom":"none"}} id="publications">
            <div className="section-title">Selected Publications</div>
            <div className='consec' style={{"padding-top":"1rem", "padding-left":"1rem", "padding-right":"1rem", "padding-bottom":"1rem"}}>
              
              <div className="publication-item">
                <div className="publication-image">
                  <img src="./imucoco.png" alt="IMUCoCo System Architecture and Results" className="project-image" />
                </div>
                <div className="publication-content">
                  <div className="publication-header">
                    <div className="project-title">
                      <span>🥥 IMUCoCo 惯性椰子</span>
                      <span className="venue-badge">UIST '25</span>
                    </div>
                    <h6 className="publication-title">Enabling Flexible On-Body IMU Placement for Human Pose Estimation and Activity Recognition</h6>
                  </div>
                  <div className="publication-authors">Haozhe Zhou, Riku Arakawa, Yuvraj Agarwal, Mayank Goel</div>
                  <div className="publication-description">
                    <p>IMUCoCo (IMU over Continuous Coordinates) maps on-body IMU signals from various placements into a unified feature space for human motion sensing tasks. It enables pose estimation from flexible placement, moving devices based on applications, and potential new IMU device form factors.</p>
                    <div className="publication-links">
                      <a href="https://dl.acm.org/doi/pdf/10.1145/3746059.3747695" target="_blank" rel="noopener noreferrer" className="link-badge">Paper</a>
                      <a href="https://www.youtube.com/watch?v=xvAj5sMCnsY" target="_blank" rel="noopener noreferrer" className="link-badge">Video</a>
                      <a href="https://github.com/cmusmashlab/IMUCoCo" className="link-badge">Code</a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="publication-item">
                <div className="publication-image">
                  <img src="./thingpoll.png" alt="ThingPoll Privacy Negotiation Interface and User Study Results" className="project-image" />
                </div>
                <div className="publication-content">
                  <div className="publication-header">
                    <div className="project-title">
                      <span>🤝 ThingPoll 隐私劝架</span>
                      <span className="venue-badge">CHI '24</span>
                    </div>
                    <h6 className="publication-title">Bring Privacy To The Table: Interactive Negotiation for Privacy Settings of Shared Sensing Devices</h6>
                  </div>
                  <div className="publication-authors">Haozhe Zhou, Mayank Goel, Yuvraj Agarwal</div>
                  <div className="publication-description">
                    <p>ThingPoll is a system that enables multiple users to negotiate privacy configurations for a sensing device in shared space. It mediates the negotiation process by strategically eliciting user preferences and suggesting configurations.</p>
                    <div className="publication-links">
                      <a href="https://dl.acm.org/doi/pdf/10.1145/3613904.3642897" target="_blank" rel="noopener noreferrer" className="link-badge">Paper</a>
                      <a href="https://www.youtube.com/watch?v=vvq-wUp64MA" target="_blank" rel="noopener noreferrer" className="link-badge">Video</a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="publication-item">
                <div className="publication-image">
                  <img src="./kirigami.png" alt="Kirigami Architecture and Performance Results" className="project-image" />
                </div>
                <div className="publication-content">
                  <div className="publication-header">
                    <div className="project-title">
                      <span>✂️ Kirigami 剪纸无语</span>
                      <span className="venue-badge">UbiComp '24</span>
                    </div>
                    <h6 className="publication-title">Lightweight Speech Filtering for Privacy-Preserving Activity Recognition using Audio</h6>
                  </div>
                  <div className="publication-authors">Sudershan Boovaraghavan, Haozhe Zhou, Mayank Goel, Yuvraj Agarwal</div>
                  <div className="publication-description">
                    <p>Kirigami is a lightweight speech filter that runs on edge devices for privacy-preserving audio-based human activity recognition. Different from conventional signal processing methods, Kirigami crops the frames out from the time-frequency spectrogram whenever it detects speech.</p>
                    <div className="publication-links">
                      <a href="https://dl.acm.org/doi/pdf/10.1145/3643502" target="_blank" rel="noopener noreferrer" className="link-badge">Paper</a>
                      <a href="https://synergylabs.github.io/kirigami/" target="_blank" rel="noopener noreferrer" className="link-badge">Video</a>
                      <a href="https://github.com/synergylabs/kirigami" target="_blank" rel="noopener noreferrer" className="link-badge">Code</a>
                    </div>
                  </div>
                </div>
              </div>

                  </div>
                </div>
                </Fade>

                <Fade>
                  <div className="consec" style={{"border-bottom":"none", "border-top":"none"}} id="contacts">
                    <div className="section-title"> Contact </div>
                    <div className="socialdiv" style={{"display":"flex", "justify-content":"space-around"}}>
                        <div className="social_icon">
                          <a href={'https://github.com/haozheee'} className="contactlink">GitHub</a>
                        </div>
                        <div className="social_icon">
                          <a href={'https://www.linkedin.com/in/haozhe-zhou-8b6882170/'} className="contactlink">LinkedIn</a>
                        </div>
                        <div className="social_icon">
                          <ButtonMailto label="E-Mail" mailto="mailto:haozhezh@cs.cmu.edu"/>
                        </div>
                    </div>
                  </div>
              </Fade>
            </div>
            )
        }
    }

    export default Home
